import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import { Biscuit, Notification } from "../../../../utils";
import { $, _ } from "../../../../../vendor";
import { errorsActions, useSelector } from "inbooma-api";
import { getContentModifications } from "../../../../App";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import SortNav from "../../../components/SortNav";
import ErrorsList from "./ErrorsList";
import ErrorsSidebar from "./ErrorsSidebar";

const ErrorsView = (props) => {
  let language = Biscuit.get("user.lang").replace("-", "_");
  const [initialized, setInitialized] = useState(false);
  const [filter, setFilter] = useState({});
  const [sort, setSort] = useState({
    sort: "id",
    direction: "desc",
  });
  const paginationLimit = 40;
  const [pagination, setPagination] = useState({
    has_next_page: false,
    current_page: 1,
  });

  const _errors = useSelector((state) => state.errors_data.getErrors);
  const _types = useSelector((state) => state.errors_data.getErrorTypes);
  const [errorsPending, setErrorsPending] = useState(false);
  const [errors, setErrors] = useState([]);
  const [types, setTypes] = useState([]);

  const _error = useSelector((state) => state.errors_data.getError);
  const [errorPending, setErrorPending] = useState(false);
  const [typesPending, setTypesPending] = useState(false);
  const [error, setError] = useState([]);

  const [resetFilter, setResetFilter] = useState(false);

  useEffect(() => {
    if (errorPending === false || _error.success === "") {
      return;
    }
    if (_error.success === true) {
      setError(_error.data);
      //setIndex(_resource.data.id);
    } else {
      console.log("Failed fetching error!");
    }
    setErrorPending(false);

    if (!errorsPending) {
      setInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_error]);

  useEffect(() => {
    if (errorsPending === false || _errors.success === "") {
      return;
    }

    if (_errors.success === true) {
      setErrors(_errors.data);
      setPagination({ ..._errors.pagination });
    } else {
      console.log("Failed fetching errors!");
    }
    setErrorsPending(false);
    if (!errorPending) {
      setInitialized(true);
    }
    $(window).scrollTop(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_errors]);

  useEffect(() => {
    if (typesPending === false || _types.success === "") {
      return;
    }

    if (_types.success === true) {
      setTypes(_types.data);
    } else {
      console.log("Failed fetching types!");
    }
    setTypesPending(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_types]);

  const loadNextPage = (page) => {
    if (!pagination.has_next_page) return;

    setErrorsPending(true);

    let requestFilter = { ...filter };
    requestFilter.sort = sort.sort;
    requestFilter.direction = sort.direction;
    requestFilter.limit = paginationLimit;
    requestFilter.page = page;
    // fetch next page
    props.dispatch(
      errorsActions.getErrors({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
  };

  const filterChangedHandle = (filter, sorts = null) => {
    let requestFilter = { ...filter };
    if (sorts === null) {
      sorts = sort;
    } else {
      setSort(sorts);
    }
    requestFilter.sort = sorts.sort;
    requestFilter.direction = sorts.direction;
    if (typeof filter.limit !== "undefined") {
      requestFilter.limit = filter.limit;
      if (typeof requestFilter.page !== "undefined") {
        delete requestFilter.page;
      }
    } else {
      requestFilter.limit = paginationLimit;
      requestFilter.page = 1;
    }

    props.dispatch(
      errorsActions.getErrors({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setErrorsPending(true);
    setFilter(filter);
  };

  const submenuItems = [
    {
      name: t("API", null, "capital"),
      link: "errors",
      data_inb_val: t("API", null, "capital"),
      icon: "fi fi-list-thumbnails",
      isActive: true,
      isAccessible: Biscuit.get("user.is_superuser") === "true",
    },
    {
      name: t("APP", null, "capital"),
      link: "apperrors",
      data_inb_val: t("APP", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: Biscuit.get("user.is_superuser") === "true",
    },
  ];
  const onSortChangedHandle = (ev) => {
    const el = ev.currentTarget;
    const sortKey = el.getAttribute("data-inb-val"),
      direction = el.getAttribute("data-inb-direction"),
      isOppositeElement = direction === null && el.classList.contains("is-active"),
      newDirection = direction === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      let requestFilter;
      if (typeof filter.limit !== "undefined") {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
        };
      } else {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
          limit: paginationLimit,
          page: 1,
        };
      }
      props.dispatch(
        errorsActions.getErrors({
          token: Biscuit.get("token"),
          suffix: "",
          filter: requestFilter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setErrorsPending(true);
      setSort({
        sort: sortKey,
        direction: direction,
      });

      const activeSortTab = $(".is-active");
      _.each(activeSortTab, function (key, value) {
        key.classList.remove("is-active");
      });
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }
  };

  const initialize = () => {
    if (initialized || errorsPending || errorPending) return;
    let requestFilter = { ...filter };
    requestFilter = { ...requestFilter, page: 1 };
    requestFilter = { ...requestFilter, limit: paginationLimit };
    requestFilter = { ...requestFilter, sort: sort.sort };
    requestFilter = { ...requestFilter, direction: sort.direction };
    if (
      props.params !== null &&
      typeof props.params[1] !== "undefined" &&
      props.params[0] === "id"
    ) {
      requestFilter = { ...requestFilter, id: props.params[1] };
    }
    props.dispatch(
      errorsActions.getErrors({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setErrorsPending(true);
    props.dispatch(
      errorsActions.getErrorTypes({
        token: Biscuit.get("token"),
        suffix: "",
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setTypesPending(true);
    if (
      props.params !== null &&
      !(location.pathname.indexOf("errors/add") >= 0) &&
      typeof props.params[0] !== "undefined" &&
      props.params[0] !== "add" &&
      props.params[0] !== "id"
    ) {
      props.dispatch(
        errorsActions.getError({
          token: Biscuit.get("token"),
          id: props.params[0],
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setErrorPending(true);
    }
  };

  if (!initialized) initialize();

  const _exchangeLabel = (value) => {
    let cm = getContentModifications();
    if (cm.labels != null) {
      if (cm.labels[value] !== undefined) {
        return cm.labels[value];
      }
    }
    return value;
  };

  const showNotification = (msgType, itemId, apiMsg) => {
    // little delay necessary to make notifications visible (render of background must be done before)
    setTimeout(() => {
      if (msgType === "success") {
        new Notification({
          message: t("saved_${a}", { a: t("resource") }, "capital") + " #" + itemId,
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-check",
        });
      } else if (msgType === "warning") {
        new Notification({
          message:
            typeof apiMsg !== "undefined" && apiMsg !== null
              ? t(apiMsg, null, "capital")
              : t("request_error", null, "capital"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });
      }
    }, 200);
  };

  let tabs = [
    {
      name: t("id"),
      mediumWidth: 1,
      smallWidth: 1,
      title: t("sort_by_${a}", { a: t("id") }),
      canSort: true,
      extraClasses: "inb-order-big",
      sort: {
        direction: "desc",
        data_inb_val: "id",
      },
    },
    {
      name: t("url", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      title: t("url"),
      canSort: false,
      extraClasses: "inb-order-big",
    },
    {
      name: t("priority", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      extraClasses: "inb-order-big",
      title: t("priority", null, "capital"),
      canSort: true,
      sort: {
        direction: "desc",
        data_inb_val: "priority",
      },
    },
    {
      name: t("type", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      extraClasses: "inb-order-big",
      title: t("type", null, "capital"),
      canSort: false,
    },
    {
      name: t("code", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      extraClasses: "inb-order-big",
      title: t("code", null, "capital"),
      canSort: false,
    },
    {
      name: t("message", null, "capital"),
      mediumWidth: 1,
      smallWidth: 2,
      extraClasses: "inb-order-big",
      title: t("message", null, "capital"),
      canSort: false,
    },
    {
      name: t("Client ID", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      extraClasses: "inb-order-big ",
      title: t("sort_by_${a}", { a: t("Client ID") }),
      canSort: true,
      sort: {
        direction: null,
        data_inb_val: "client_id",
      },
    },
    {
      name: t("Request"),
      mediumWidth: 1,
      smallWidth: 1,
      extraClasses: "inb-order-big",
      title: t("Request", null, "capital"),
      canSort: false,
    },
    {
      name: t("Header", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      title: t("header"),
      canSort: false,
    },
    {
      name: t("Response Data", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      title: t("Response Data"),
      canSort: false,
    },
    {
      name: t("Stack Trace", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      title: t("Stack Trace"),
      canSort: false,
    },
    {
      name: t("created", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      title: t("sort_by_${a}", { a: t("created") }),
      canSort: true,
      sort: {
        direction: null,
        data_inb_val: "created",
      },
    },
  ];

  return (
    <>
      {initialized && !typesPending && (
        <ErrorsSidebar
          dispatch={props.dispatch}
          heading={t("Errors (API)")}
          filterChangedHandle={filterChangedHandle}
          filter={filter}
          setFilter={setFilter}
          resetFilter={resetFilter}
          setResetFilter={setResetFilter}
          sort={sort}
          types={types}
        />
      )}
      <div id="inb-c-main" className="columns">
        <InboomaSubmenu
          tabs={submenuItems}
          smallOnlyTitle={t("errors", null, "capital")}
          extraClasses={"sticky-top"}
          pagination={pagination}
          itemLength={errors.length}
          itemsCountPerPage={paginationLimit}
          pageRangeDisplayed={5}
          showPagination={true}
          onChange={loadNextPage}
          initialized={initialized}
        />

        <SortNav
          tabs={tabs}
          extraId={"error-nav"}
          extraClasses={"sticky-top-sortbar"}
          //margStyle={{top:"63px"}}
          listStyle="tight"
          handler={onSortChangedHandle}
        />
        {/* {initialized && errors.length > 0 && !errorsPending && typeof pagination !== 'undefined' &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                    />} */}
        {initialized && errors.length > 0 && !errorsPending && (
          <ErrorsList
            errors={errors}
            dispatch={props.dispatch}
            _exchangeLabel={_exchangeLabel}
            filterChangedHandle={filterChangedHandle}
            filter={filter}
            key={"inb-c-main-resources"}
            sort={sort}
            setSort={setSort}
            setInitialized={setInitialized}
          />
        )}
        {initialized &&
          (errors.length < 1 || typeof errors.length === "undefined") &&
          !errorsPending && (
            <>
              <div id="inb-app-collection-empty" className="inb-announcement">
                <div className="inb-image-box">
                  <img src="assets/img/no_data.svg" />
                </div>
                <h3>{t("app_msg_collection_empty")}</h3>
                <p>{t("app_msg_collection_empty_body")}</p>
              </div>
            </>
          )}
        {/* {initialized && errors.length > 0 && !errorsPending && typeof pagination !== 'undefined' &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                    />} */}
        {errorsPending && (
          <>
            {" "}
            <div id="inb-app-collection-empty" className="inb-announcement">
              <div className="inb-image-box">
                <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
              </div>
            </div>
          </>
        )}

        {/* {((props.params !== null && props.params[0] !== 'id' && Biscuit.get('user.role') === 'admin' && initialized && !errorPending)) &&
                <ItemView
                    onClose={onCloseResource}
                    dispatch={props.dispatch}
                    locations={locations}
                    contingents={contingents}
                    filterChangedHandle={filterChangedHandle}
                    filter={filter}
                    showNotification={showNotification}
                    requestPath={props.returnPath}
                    resource={index !== null?resources[index]:resource}
                    setIndex={setIndex}
                    setAdd={setAdd}
                    setResource={setResource}
                    setResourcesPending={setResourcesPending}
                />
                }
                {((props.params !== null && props.params[0] !== 'id' && Biscuit.get('user.role') !== 'admin' && initialized && !resourcePending) || index !== null || add !== false)  &&
                <ItemViewService
                    onClose={onCloseResource}
                    dispatch={props.dispatch}
                    locations={locations}
                    contingents={contingents}
                    filterChangedHandle={filterChangedHandle}
                    filter={filter}
                    showNotification={showNotification}
                    requestPath={props.returnPath}
                    resource={index !== null?resources[index]:resource}
                    setIndex={setIndex}
                    setAdd={setAdd}
                    setResource={setResource}
                    setResourcesPending={setResourcesPending}
                />
                }*/}
      </div>
    </>
  );
};

export default ErrorsView;
